import React, { useState, useEffect } from 'react';
import { List, Box, Pagination, Stack } from '@mui/material';
import CardRouter from '../cards/CardRouter';

const ITEMS_PER_PAGE = 10;

const ResultsList = ({ hits }) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Reset to page 1 when hits change
  useEffect(() => {
    setCurrentPage(1);
  }, [hits]);

  // Calculate pagination
  const totalPages = Math.ceil(hits.length / ITEMS_PER_PAGE);
  const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIdx = startIdx + ITEMS_PER_PAGE;
  const currentHits = hits.slice(startIdx, endIdx);

  // Handle page change
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    // Scroll to top of list for better UX
    event.currentTarget.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  };

  const PaginationComponent = () => (
    <Stack direction="row" justifyContent="center" sx={{ py: 1 }}>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        size="small"
        showFirstButton
        showLastButton
      />
    </Stack>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
      <PaginationComponent />
      <List sx={{ width: '100%', flex: 1, overflow: 'auto' }}>
        {currentHits.map((hit, idx) => (
          <CardRouter key={`${currentPage}-${idx}`} hit={hit} />
        ))}
      </List>
      <PaginationComponent />
    </Box>
  );
};

export default React.memo(ResultsList);

